import { forwardRef } from 'react';
import { type VariantProps, cva } from 'class-variance-authority';

import classNames from '@/utils/classnames';

export const textareaVariants = cva(
  'w-full resize-none rounded-lg border bg-surface-2 px-3 py-2 text-sm text-fg placeholder:text-fg-disabled outline-none transition-colors focus:ring-1 disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      error: {
        true: 'border-danger focus:border-danger focus:ring-danger/20',
        false: 'border-line focus:border-brand-border focus:ring-brand/15',
      },
    },
    defaultVariants: {
      error: false,
    },
  },
);

export interface TextareaProps
  extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'className'>, VariantProps<typeof textareaVariants> {
  className?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ error, className, ...props }, ref) => (
  <textarea ref={ref} className={classNames(textareaVariants({ error }), className)} {...props} />
));
Textarea.displayName = 'Textarea';
